export default Object.freeze({
  ARROW_UP: 'arrow-up',
  ARROW_DOWN: 'arrow-down',
  ARROW_LEFT: 'arrow-left',
  ARROW_RIGHT: 'arrow-right',
  ARROW_UP_LEFT: 'arrow-up-left',
  ARROW_UP_RIGHT: 'arrow-up-right',
  ARROW_DOWN_LEFT: 'arrow-down-left',
  ARROW_DOWN_RIGHT: 'arrow-down-right',
  STAIRS_UP_LEFT: 'stairs-up-left',
  STAIRS_UP_RIGHT: 'stairs-up-right',
  STAIRS_DOWN_LEFT: 'stairs-down-left',
  STAIRS_DOWN_RIGHT: 'stairs-down-right',
  ELEVATOR_UP: 'elevator-up',
  ELEVATOR_DOWN: 'elevator-down',
  OPERATOR: 'operator',
  FLAG: 'flag'
});
